/**
 * @format
 */

import {
  FormatListBulleted,
  FormatListBulletedAdd,
  ViewModule,
} from '@mui/icons-material';
import { useEffect, useState } from 'react';
import {
  createRole,
  getAllModules,
  getAllRoles,
  updateRole,
} from '../../../core/services/admin.service';
import { getAllJobTitles } from '../../../core/services/jobTitle.service';
import ManagementPage from '../../../pages/shared/ManagementPage';
import ListRoles from '../components/ListRoles';
import RoleForm from '../components/RoleForm';

const TABS = [
  { value: 1, icon: <FormatListBulleted />, label: 'Permission List' },
  { value: 0, icon: <FormatListBulletedAdd />, label: 'Permission Form' },
];

const initRoleForm = {
  jobTitles: [], // [1,2 ]
  modules: [], // [1,2]
  canView: false,
  canEdit: false, // when edit is true, view is also true.
  isUpdate: false, // Not required in payload, to decide whethere the form is update or create new.
};

const PermissionsPage = () => {
  const [tabIndex, setTabIndex] = useState(1);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  const [roles, setRoles] = useState([]);

  const [roleForm, setRoleForm] = useState(initRoleForm);

  const [options, setOptions] = useState({
    jobTitles: [], // [{ jobTitleId, jobTitleName, statusId }]
    modules: [], // [{ moduleOperationId, moduleOperationName, statusId }]
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const updateRoleForm = function (key, val) {
    setRoleForm((prev) => ({ ...prev, [key]: val }));
  };

  const fetchJobsAndModules = () => {
    getAllJobTitles().then((data) => {
      setOptions((prev) => ({ ...prev, jobTitles: data }));
    });
    getAllModules().then((data) => {
      setOptions((prev) => ({ ...prev, modules: data }));
    });
  };

  const fetchRoles = async () => {
    try {
      const data = await getAllRoles();
      setRoles(data);
    } catch (error) {
      console.error('Error fetching roles:', error);
    }
  };

  const handleCreateRole = async (role) => {
    const payload = {
      jobTitleId: role.jobTitles.map((jt) => jt.jobTitleId),
      moduleOperationId: role.modules.map((m) => m.moduleOperationId),
      canView: role.canView,
      canEdit: role.canEdit,
      canCreate: false, // default
      canDelete: false, // default
    };
    try {
      await createRole(payload);
      setSnackbar({
        open: true,
        message: 'Created a new role',
        severity: 'success',
      });
    } catch (error) {
      console.error('Error creating role:', error);
      setSnackbar({
        open: true,
        message: 'Something went wrong',
        severity: 'error',
      });
    }
  };

  const handleUpdateRole = async (role, id) => {
    try {
      await updateRole(role, id);
      setSnackbar({
        open: true,
        message: 'Updated role',
        severity: 'success',
      });
    } catch (error) {
      console.error('Error updating role:', error);
      setSnackbar({
        open: true,
        message: 'Something went wrong',
        severity: 'error',
      });
    }
  };

  // Switch to the Create Role tab pre-filled with the clicked role's data.
  const handleActiveRole = (role) => {
    setRoleForm({
      ...role,
      jobTitles: [role.jobTitleId],
      modules: [role.moduleOperationId],
      canView: !!role.view,
      canEdit: !!role.edit,
      isUpdate: true,
    });
    setTabIndex(2);
  };

  useEffect(() => {
    if (tabIndex === 1) {
      fetchRoles();
    }
  }, [tabIndex]);

  useEffect(() => {
    fetchJobsAndModules();
  }, []);

  return (
    <ManagementPage
      title="Permission Management"
      icon={<ViewModule />}
      tabs={TABS}
      tabIndex={tabIndex}
      onTabChange={setTabIndex}
      snackbar={snackbar}
      onSnackbarClose={handleSnackbarClose}
    >
      {tabIndex === 1 ? (
        <ListRoles
          roles={roles}
          options={options}
          handleActiveRole={handleActiveRole}
        />
      ) : (
        <RoleForm
          roleForm={roleForm}
          options={options}
          updateRoleForm={updateRoleForm}
          handleCreateRole={handleCreateRole}
          handleUpdateRole={handleUpdateRole}
        />
      )}
    </ManagementPage>
  );
};

export default PermissionsPage;
